/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import {
  Button,
  Colors,
  Spacer,
  Text,
  Typography,
} from '@zapier/design-system';

import List from '../../shared/List';
import Surface from '../..//shared/Surface';
import ExternalLink from '../../shared/ExternalLink';
import ConversationLink from './ConversationLink';
import { SizeType } from '../../../types';

type Link = {
  href: string;
  title: string;
  snippet?: string;
};

type CommunityStepProps = {
  /** Conversations to link */
  links: Link[];
  /** Size to display. */
  size?: SizeType;
};

const RebrandStyles = {
  browseLink: {
    ...Typography.SmallPrint4,
    color: Colors.UiPrimaryStrongest,
  },
};

/** Renders the content for the community-step in the form. */
const CommunityStep = ({ links, size = 'large' }: CommunityStepProps) => {
  return (
    <Surface size={size} title="Find a solution in our Community">
      <Spacer height={14} />
      <List
        gap={5}
        itemRenderer={(item: Link) => (
          <ConversationLink {...item} size={size} />
        )}
        items={links}
      />
      <Spacer height={20} />
      <ExternalLink
        css={RebrandStyles.browseLink}
        href="https://community.zapier.com/ask-the-community-3"
      >
        Browse Community
      </ExternalLink>
      <Spacer height={40} />
      <Text tag="p" type="Body4">
        You can also ask your own question
      </Text>
      <Spacer height={15} />
      <Button
        color="secondary"
        href="https://community.zapier.com/topic/new"
        target="_blank"
      >
        Ask our Community
      </Button>
    </Surface>
  );
};

export default CommunityStep;
